import { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { useGenericSend } from './useGenericSend';
import { TServerSendResponse, IServerSendResponse } from '../types';

export const useCheckUserEmailVerificationStatus = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback((token: string): Promise<IServerSendResponse> =>
        send<{ token: string; casinoName: string }, TServerSendResponse>({
            ID: 35556,
            description: 'Check User Email Verification Status',
            responses: [35557, 35558],
            token,
            casinoName
        }), [send, casinoName]);
};
